<template>
    <div class="message-deliverable-table">
        <general-table
            :columns="columns"
            :filters="filters"
            :url="route('md.table.scheduled')"
        >
        </general-table>
        
        <create-message-modal 
            v-if="showEditModal" 
            :modal-open="showEditModal" 
            @close="showEditModal = false; updateTable()"
            :md="mdForEdit"
        />

        <jet-dialog-modal v-if="showDeletionModal" @close="showDeletionModal = false" :show="showDeletionModal">
            <template #title>
                Delete Scheduled Message
            </template>

            <template #content>
                Are you sure you want to delete this scheduled message?
            </template>

            <template #footer>
                <button @click="showDeletionModal = false">
                    Cancel
                </button>
                <jet-danger-button
                    class="ml-2"
                    @click.native="deleteMessageDeliverable(idSetForDeletion)"
                >
                    Delete Message
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
    </div>
</template>

<script>
import ScheduledMessageTableActions from "./ScheduledMessageTableActions";
import MessageDeliverableTableName from "./MessageDeliverableTableName";
import MessageDeliverableDeleteButton from "./MessageDeliverableDeleteButton";
import MessageSentTableRecipientName from "./MessageSentTableRecipientName.vue";
import MessageTableSendTime from "./MessageTableSendTime";
import axios from "axios";
import MessageForm from "./MessageForm";
import JetDialogModal from '../Jetstream/DialogModal';
import JetDangerButton from '../Jetstream/DangerButton';
import MessageTableMessage from "./MessageTableMessage";
import GeneralTable from "./GeneralTable/GeneralTable";
import { useGeneralTableStore } from '@/Stores/general_table';
import { mapActions } from 'pinia';
import {markRaw} from 'vue';
import CreateMessageModal from "./CreateMessageModal";
export default {
    components: {
        JetDialogModal,
        JetDangerButton,
        MessageDeliverableDeleteButton,
        ScheduledMessageTableActions,
        MessageDeliverableTableName,
        MessageForm,
        GeneralTable,
        CreateMessageModal,
    },
    data() {
        return {
            columns: [
                {
                    label: "SEND DATE/TIME",
                    name: "scheduled_send_time",
                    sortable: true,
                    width: '200px',
                    component: markRaw(MessageTableSendTime),
                },
                {
                    label: "RECIPIENT",
                    name: "recipient_name",
                    sortable: false,
                    width: '240px',
                    component: markRaw(MessageSentTableRecipientName),
                },
                {
                    label: "MESSAGE",
                    name: "unparsed_message",
                    sortable: false,
                    width: '1fr',
                    component: markRaw(MessageTableMessage),
                },
                {
                    label: '',
                    name: 'View',
                    sortable: false,
                    event: "click",
                    width: '100px',
                    eventHandler: this.handleButtonClick,
                    component: markRaw(ScheduledMessageTableActions),
                },
            ],
            filters: [
                {
                    label: "Contact",
                    value: "contact",
                    type: "contact",
                    multiple: false, // because contact component already supports multiple
                },
                {
                    label: "List",
                    value: "list",
                    type: "list",
                    multiple: true,
                },
                {
                    label: "Send Date Since",
                    value: "send_date_start",
                    type: "date",
                    multiple: false,
                },
                {
                    label: "Send Date Until",
                    value: "send_date_end",
                    type: "date",
                    multiple: false,
                },
                {
                    label: 'Recipient Type',
                    value: 'recipient_type',
                    type: 'select',
                    multiple: false,
                    options: [
                        { label: 'Contact', value: 'contact' },
                        { label: 'List', value: 'list' },
                    ]
                }
            ],
            showDeletionModal: false,
            showEditModal: false,
            mdForEdit: null,
            idSetForDeletion: null,
        }
    },

    methods: {
        ...mapActions(useGeneralTableStore, [
            'fetchData', 'clearData',
        ]),
        updateTable() {
            this.clearData();
            this.fetchData();
        },
        deleteMessageDeliverable(id) {
            axios
                .post(route("md.delete", { id: id }))
                .then((res) => {
                    this.$toasted.show(`Message has been deleted.`, {
                        position: "bottom-right",
                        type: "success",
                        duration: 1000
                    });
                })
                .catch((err) => {
                    this.$toasted.show(
                        `There's been an error deleting your scheduled message, please try again.`,
                        {
                            position: "bottom-right",
                            type: "error",
                            duration: 1000
                        }
                    );
                }).finally(() => {
                    //reload the table
                    this.clearData();
                    this.fetchData();
                    this.showDeletionModal = false;
                })
        },
        handleButtonClick(data, type) {
            if ( type === 'delete' ) {
                this.toggleDeletionModal(data);
            }

            if ( type === 'edit' ) {
                this.$inertia.visit(route('messages.edit', data.tra_id))
            }
        },
        toggleDeletionModal(data) {
            this.idSetForDeletion = data.id;
            this.showDeletionModal = true;
        },
        toggleEditModal(data) {
            this.mdForEdit = data;
            this.showEditModal = true;
        }
    }
};
</script>

<style>

/* showSearchFilter didn't seem to work as table prop, so just manually hiding this for now */
.message-deliverable-table input[name=table-search] {
    display: none;
}

</style>